/**
 *    @author: Andrew Sheen
 *    @since:  2020-10-30
 */

import { Component,OnInit,  AfterViewInit, ElementRef,Input,Output, EventEmitter } from '@angular/core';
import { ControlBaseComponent } from "../control-base.component";
import { DeviceDetectorService } from 'ngx-device-detector';
import { TimerService } from 'src/refresh/service/timer-service';
import { Util } from 'src/refresh/service/Util';


@Component({ 
  selector: 'ng-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.less']
})       
export class InputComponent extends ControlBaseComponent implements OnInit, AfterViewInit {
       //--------------------------------------------------------------------
       private static id_no:number = 1;
        
       @Input() size: number = 16;
       @Input() type: string = "text";
       @Input() max:  number;
       @Input() placeholder: string = "";
       @Input() option:  number;

       @Output('blur')   blurChange  = new EventEmitter<any>();
       @Output('focus')  focusChange = new EventEmitter<any>();
       //@Output('change')  : this works , fire when blured.

      // private controlMargin = "control-margin "
       //--------------------------------------------------------------------
        public get className():string {
             //return this.controlMargin + this.class_name;
             return this.class_name;
        }

        public get inputClass():string {
               return "ontario-input " + this.input_class;
        }

        public get labelClass():string {
               return "input-label "+this.label_class;
        }

        private inputCtrl:any;

        constructor(private elRef:ElementRef, private device: DeviceDetectorService,protected timerService:TimerService) { 
                    super(timerService,3);
        }  

        private inline:any;
        public ngOnInit(): void {

               
               this.inputCtrl = this.elRef.nativeElement.querySelector('input');
               this.inline    = this.inputCtrl.parentElement.parentElement.getAttribute("inline");
               
               if ( this.inline != null  && this.inline !==  'false' ) {
                    this.inline = true;
                    if ( this.label_class )  this.label_class += " inline";
                    else                     this.label_class = "inline";

                    this.labelStyle = "margin-right:0.44em";
                    ///this.controlMargin = "";
               }
               else if ( !this.class_name ) this.class_name = "control-margin ";


               if ( !this.id ) {
                     this.id = this.type+"_"+InputComponent.id_no++;
               }

               if ( !this.max ) {
                     this.max = this.size;
               }

               if ( this.option ) {
                    this.controlType = this.option;
               }

               super.errorParamSet();
        }

        public ngAfterViewInit() {

            if ( this.type == "number" || this.type == "tel" ) {  
                 this.inputCtrl.style.width = this.size + "em";
                 ////this.inputCtrl.style.textAlign="center";
            }

            if ( this.size >= 29 && this.device.isMobile() ) {
                 this.inputCtrl.style.width = "100%";
            }

            /**
            let ctrlWidth = this.inputCtrl.getBoundingClientRect().width+1;

            if ( this.inline === true ) {
                 let labelTag = this.elRef.nativeElement.querySelector('label');
                 ctrlWidth += labelTag.getBoundingClientRect().width + 12;
            }
            
            this.inputCtrl.parentElement.style.width = ctrlWidth  +"px";
             */                  
            super.layoutFromViewInit(this.inputCtrl.parentElement);
        }

      
        public onBlur() {
               if ( this.type == "number" ) {
                    let value:number = null;
                    if ( this.input )  value = parseInt(this.input);
                    this.inputChange.emit(value);
                    this.blurChange.emit(value);
                    return;
               }

               if ( this.input ) this.input = Util.trim(this.input);
               
               this.inputChange.emit(this.input);
               this.blurChange.emit(this.input);
               this.timerService.reset();
        }

        public onFocus() {
               this.focusChange.emit(this.input);
               this.timerService.reset();
        }
      
        public onKeyPress(event:any) {
              if ( event.keyCode == 13 ) {
                   this.inputCtrl.blur();
              }
              else
              if ( this.type == 'tel' ) {
                   if ( event.keyCode < 48 || event.keyCode > 57 ) {
                        event.preventDefault();
                        event.stopPropagation();
                   } 
              }
        }
}

